export default __webpack_public_path__ + "static/media/prestation france.48413158.png";